module.exports = __webpack_public_path__ + "img/light_ic_creation_step1.8179cb3b.png";